import { Injectable } from '@angular/core'
import { ICandidatePool } from '@employer/app/models/candidate-pool.model'
import { CollectionRepository } from '@engineering11/web-api-firebase'
import { COLLECTIONS } from 'shared-lib'

@Injectable({ providedIn: 'root' })
export class CandidatePoolRepository extends CollectionRepository<ICandidatePool> {
  protected COLLECTION = COLLECTIONS.CANDIDATE_POOL
}
